export const PROPERTY_INITIAL_VALUES = {
  type: "APARTMENT_BUILDING",
  address: {
    street: "",
    city: "",
    subdivision: "NY-US",
    postalCode: "",
    country: "USA",
  },
  additionalPetsInBuilding: "",
  topFloorLevel: 0,
  photoUrls: [],
  onStreetParking: false,
  onSiteParkingIncluded: false,
  publicParkingNearby: false,
  additionalInformationMarkdown: "",
  utilities: [],
  appliances: [],
  laundry: "",
  safety: [],
  twentyFourHourMaintenance: false,
  status: "ACTIVE",
};

export const LEASE_INITIAL_VALUES = {
  propertyId: "",
  sublettingAvailable: "",
  leaseRenewal: [],
  daysGuestsAllowed: "",
  quietHours: {
    startLocalTime: "22:00:00.000",
    endLocalTime: "08:00:00.000",
  },
  proofOfRentalInsurance: "",
  tenantScreening: "",
  creditCheck: "",
  addendums: [],

  //
};

export const UNIT_INITIAL_VALUES = {
  propertyId: "",
  unitId: "",
  status: "ACTIVE",
  number: "",
  floorLevel: "",
  section8Approved: "",
  numberOfBedrooms: "",
  numberOfBathrooms: "",
  numberOfOtherRooms: "",
  numberOfParkingSpots: "",
  additionalInformationMarkdown: "",
  utilities: [],
  appliances: [],
  laundry: "",
  safety: [],
};

export const UNIT_LEASE_INITIAL_VALUES = {
  rate: {
    scale: 2,
    amount: 0,
    currency: "USD",
  },
  lateFee: {
    scale: 2,
    amount: 0,
    currency: "USD",
  },
  securityDeposit: {
    scale: 2,
    amount: 0,
    currency: "USD",
  },
  availabilityDate: "",
  // pets: "",
  // addendums: [],
};

export const LIST_INITIAL_VALUES = {
  status: "ACTIVE",
  photoUrls: [],
  ratings: {
    buildingLoudness: "",
    feltSafeInsideBuilding: "",
    feltSafeOutsideBuilding: "",
    responsiveLandlord: "",
    cleanCommonAreasInside: "",
    cleanWellMaintainedPropertyOutside: "",
    waterPressure: "",
    overallLivingExperience: "",
  },
};
